module.exports = __webpack_public_path__ + "static/media/report2018.6e20da6c.pdf";